export * from '@erp/ui/avatar';
